import clsx from 'clsx';
import React from 'react';

export function AlertFormSubmitted({ estimatedTrainingTime }) {
  return (
    <div role="alert" className={clsx('alert alert-info flex flex-col my-3')}>
      <div className="flex items-center justify-center gap-3">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          className="stroke-info-content h-7 w-7 shrink-0"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="3"
            d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          ></path>
        </svg>
        <h2 className={clsx('m-0')}>
          Udało się wysłać zadanie do kolejki obliczeń.
        </h2>
      </div>
      <p className={clsx('text-lg text-center')}>
        Po jego zakończeniu odblokujemy następny krok.
        <br />
        <br />
        Możesz również kontynuować przeglądanie strony a status zadania
        sprawdzać w prawym dolnym rogu ekranu.
      </p>
    </div>
  );
}

export function AlertTrainingTaskCompleted({
  mainMessage,
  subMessage,
  additionalContent,
}) {
  return (
    <div role="alert" className="alert alert-success flex flex-col my-3">
      <div className="flex items-center justify-center gap-3">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-7 w-7 shrink-0 stroke-current"
          fill="none"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="3"
            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
        <h2 className={clsx('m-0')}>{mainMessage}</h2>
      </div>
      <p className="text-lg text-center">{subMessage}</p>
      {additionalContent}
    </div>
  );
}

export function AlertError({ msg }) {
  return (
    <div role="alert" className="alert alert-error">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-6 w-6 shrink-0 stroke-current"
        fill="none"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
      <span>{msg}</span>
    </div>
  );
}
